import { PlusIcon } from 'lucide-react'
import type { FC, ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'

interface PromptTemplateCreateFooterProps {
  onClick: () => void
}

/**
 * Sticky footer button for creating a new prompt template inside the template popover.
 */
export const PromptTemplateCreateFooter: FC<PromptTemplateCreateFooterProps> = ({
  onClick,
}): ReactNode => (
  <div className="chat-input-templates-footer">
    <Separator />
    <div className="p-1">
      <Button
        variant="ghost"
        size="sm"
        className="chat-input-templates-create w-full justify-start gap-2"
        onClick={onClick}
      >
        <PlusIcon className="size-4" />
        Create new template
      </Button>
    </div>
  </div>
)

PromptTemplateCreateFooter.displayName = 'PromptTemplateCreateFooter'
